import {
  Input,
  InputGroup,
  InputLeftAddon,
  Text,
  UseDisclosureReturn,
} from "@chakra-ui/react";
import React from "react";
import { useForm } from "react-hook-form";
import { useCurrentAccountStore } from "../../../../store/currentAccountStore";
import { useMutationUpdateAccount } from "../../../../store/useMutationUpdateAccount";
import { FormFieldControl } from "../../../forms/FormFieldControl";
import { FormModal } from "../../../modals/FormModal";

type EditContactNumberFormValues = {
  contactNumber: string;
};

export function EditContactNumberModal({
  currentCountryCode,
  currentNumber,
  disclosure,
}: {
  currentCountryCode: string;
  currentNumber: string;
  disclosure: UseDisclosureReturn;
}): React.ReactElement {
  const countryCode = currentCountryCode || "+61";

  const values = React.useMemo<EditContactNumberFormValues>(
    () => ({
      contactNumber: currentNumber || "",
    }),
    [currentNumber],
  );

  const form = useForm<EditContactNumberFormValues>({
    values,
    mode: "onTouched",
    resetOptions: {
      keepDirtyValues: true,
    },
  });

  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const mutationUpdateAccount = useMutationUpdateAccount(accountId);

  const onSubmit = async (data: EditContactNumberFormValues) => {
    await mutationUpdateAccount.mutateAsync({
      contactNumber: {
        countryCode: data.contactNumber ? countryCode : "",
        number: data.contactNumber,
      },
    });
  };

  return (
    <FormModal
      disclosure={disclosure}
      form={form}
      title={`${currentNumber ? "Edit" : "Add"} contact number`}
      submitButtonText="Save changes"
      submitCondition="dirty"
      successTitle="Contact number updated"
      errorTitle="Update failed"
      onSubmit={onSubmit}
    >
      <Text color="gray.600" mb={6}>
        The contact number is optional and is only required if you want it
        displayed on the Crypto Tax Report.
      </Text>

      <FormFieldControl form={form} name="contactNumber" label="Contact number">
        <InputGroup>
          <InputLeftAddon>{countryCode}</InputLeftAddon>
          <Input
            type="text"
            placeholder="400 123 456"
            autoFocus
            {...form.register("contactNumber")}
          />
        </InputGroup>
      </FormFieldControl>
    </FormModal>
  );
}
